import { transformDateValue } from 'core/js/FormUtils';
export const getWorkerView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let workerList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"Title","fieldValue":transformDataValue(data.title,"string"), "fieldType":"string"},
                            {"fieldLabel":"Skill  Id","fieldValue":transformDataValue(data.skillid,"bodynamiclist"), "fieldType":"bodynamiclist"},
                            {"fieldLabel":"Skill  Name","fieldValue":transformDataValue(data.skillname,"string"), "fieldType":"string"},
                            {"fieldLabel":"Type Id","fieldValue":transformDataValue(data.typeid,"ID"), "fieldType":"ID"},
              
              
            ],
            'dataList': [
                
              ]
          }

          workerList.push(card);
  })
  return workerList;
}